import {useState, useEffect} from 'react';
import { useIsMobile } from 'hooks/useIsMobile';
import { getCardAssociate, getCardData } from 'services/Cards'
import { useToken } from 'hooks/useToken'
import { useHistory } from 'react-router-dom'
import { decodeStorage, encodeStorage } from 'functions/storageBase64'
import { BASE_PATH, SUB_DIRECTORY } from 'constants/general'

export function useConsultaSaldoPage(){

    const { isMobile } = useIsMobile();
    const { newToken, liveToken }  = useToken()
    const history = useHistory()
    const cardending = decodeStorage('cardending')
    const lastConsultData = decodeStorage('lastConsultData')
    const sears_numero_internet = decodeStorage('sears_numero_internet')
    const [udCard, setUdCard] = useState(false)


    const [response, setResponse] = useState(lastConsultData)
    const [noInternet, setNoInternet] = useState(sears_numero_internet)

    useEffect(()=>{

        if(sears_numero_internet && ( cardending && (cardending != "undefined" && cardending != "dW5kZWZpbmVk" ) ) ){
            if(udCard){
                liveToken()
                getCardData(sears_numero_internet, decodeStorage('cardending'))
                .then(setResponse)
                setNoInternet(sears_numero_internet, decodeStorage('cardending'))
                setUdCard(false)
            }
        }
    },[newToken, udCard])
    
    // useEffect(()=>{

    //     if(sears_numero_internet != "undefined"  && (cardending != "undefined" || cardending != "dW5kZWZpbmVk" ) ){
    //         if(udCard){
    //             liveToken()
    //             getCardData(sears_numero_internet, cardending)
    //             .then(setResponse)
    //             setNoInternet(sears_numero_internet, cardending)
    //             setUdCard(false)
    //             console.log('asdas')
    //             console.log('10')
    //         }
    //     }
    // },[newToken, udCard])

    const [cardsService, setCardsService] = useState()
    const [errorCode, setErrorCode] = useState()
    useEffect(()=>{

        //console.log('response: ',response)
        if(response){
            if(response.statusCode === 200){
                let dataProduct = response.data
                dataProduct[0].noInternet = sears_numero_internet

                setCardsService(dataProduct)
            }else if(response.statusCode >= 400 && response.statusCode <= 499){
                let codeError = JSON.parse(response.data)
                setErrorCode(codeError)
            }
            else if(response.statusCode >= 500 ){
                setErrorCode(response.statusCode)
                console.log('as: ',response.statusCode)
            }
        }
    },[response])

    
    useEffect(()=>{
        if(cardsService && cardsService.length === 0){
            history.push(`${BASE_PATH}${SUB_DIRECTORY}`)
        }
        else if(!sears_numero_internet || sears_numero_internet === "undefined"){
            history.push(`${BASE_PATH}${SUB_DIRECTORY}`)
        }
    },[cardsService])

    return{
        cardsService,
        setUdCard,
        noInternet,
        errorCode,
        isMobile
    }
}